export function dateOnly(value) {
  if (!value) return '';

  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    const y = value.getFullYear();
    const m = String(value.getMonth() + 1).padStart(2, '0');
    const d = String(value.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }

  const raw = String(value);
  const ymd = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (ymd) return `${ymd[1]}-${ymd[2]}-${ymd[3]}`;

  const us = raw.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})/);
  if (us) return `${us[3]}-${us[1].padStart(2, '0')}-${us[2].padStart(2, '0')}`;

  return raw.slice(0, 10);
}

export function parseDbDate(value) {
  const raw = dateOnly(value);
  if (!raw) return null;
  const [year, month, day] = raw.split('-').map(Number);
  if (!year || !month || !day) return null;
  return new Date(year, month - 1, day, 12, 0, 0, 0);
}

export function toDateInputValue(value = new Date()) {
  if (value instanceof Date) return dateOnly(value);
  return dateOnly(value);
}

export function formatDate(value, fallback = '') {
  const raw = dateOnly(value);
  if (!raw) return fallback;
  const [year, month, day] = raw.split('-');
  if (!year || !month || !day) return fallback || raw;
  return `${month}/${day}/${year}`;
}

export function formatDateRange(startValue, endValue, separator = ' - ') {
  const start = dateOnly(startValue);
  const end = dateOnly(endValue || startValue);
  if (!start) return '';
  const startLabel = formatDate(start);
  if (!end || end === start) return startLabel;
  return `${startLabel}${separator}${formatDate(end)}`;
}

export function formatDateTime(value, options = {}) {
  if (!value) return options.fallback || '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    const dateLabel = formatDate(value, options.fallback || '');
    return dateLabel;
  }
  const dateLabel = formatDate(date);
  if (options.includeSeconds) {
    return `${dateLabel} ${date.toLocaleTimeString('en-US')}`;
  }
  return `${dateLabel} ${date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })}`;
}

export function todayDate() {
  return dateOnly(new Date());
}
